// extracted by mini-css-extract-plugin
module.exports = {"services-offered-text":"services-offered_services-offered-text__ueX0G"};